// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-webview.p-mod-hidden {
  visibility: hidden;
  display: flex !important;
}

.theia-webview {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.theia-webview iframe {
  flex-grow: 1;
  border: none;
  margin: 0;
  padding: 0;
}

.theia-webview-icon {
  background: none !important;
  min-height: 20px;
}

.theia-webview-icon::before {
  background-size: 13px;
  background-repeat: no-repeat;
  vertical-align: middle;
  display: inline-block;
  text-align: center;
  height: 15px;
  width: 15px;
  content: "";
}

.p-TabBar.theia-app-sides .theia-webview-icon::before {
  width: var(--theia-private-sidebar-icon-size);
  height: var(--theia-private-sidebar-icon-size);
  background-size: contain;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/style/webview.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,wBAAwB;AAC1B","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-webview.p-mod-hidden {\n  visibility: hidden;\n  display: flex !important;\n}\n\n.theia-webview {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.theia-webview iframe {\n  flex-grow: 1;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\n.theia-webview-icon {\n  background: none !important;\n  min-height: 20px;\n}\n\n.theia-webview-icon::before {\n  background-size: 13px;\n  background-repeat: no-repeat;\n  vertical-align: middle;\n  display: inline-block;\n  text-align: center;\n  height: 15px;\n  width: 15px;\n  content: \"\";\n}\n\n.p-TabBar.theia-app-sides .theia-webview-icon::before {\n  width: var(--theia-private-sidebar-icon-size);\n  height: var(--theia-private-sidebar-icon-size);\n  background-size: contain;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
